import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import Transition from './Transition';

const styles = (theme) => ({
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	question: {
		padding: '20px 20px 10px 20px',
		fontWeight: 600,
		fontSize: 16,
		textAlign: 'right',
	},
	actions: {
		padding: 10,
	},
	warningButton: {
		borderRadius: 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
});

class ConfirmInvalidateApArTriage extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			invalidReason: '',
		};
	}

	onChange = (event, fieldName) => {
		this.setState({ [fieldName]: event.target.value });
	};

	handleClose = () => {
		this.props.onClose();
	};

	handleInvalidate = () => {
		const {
			showErrors,
			apIngestionResultId,
			ocrIngestionResultId,
			invalidateTriageResult,
		} = this.props;
		const { invalidReason } = this.state;

		if (!invalidReason) {
			showErrors(['A reason for marking triage result invalid is required.']);
			return;
		}

		if (apIngestionResultId) {
			invalidateTriageResult({
				params: {
					apIngestionResultId,
					invalidReason,
				},
				callback: (err) => {
					if (!err) {
						this.props.history.push(`/apAutomation/apIngestionResults`);
					}
				},
			});
		} else {
			invalidateTriageResult({
				params: {
					ocrIngestionResultId,
					invalidReason,
				},
				callback: (err) => {
					if (!err) {
						this.props.history.push(`/ocr/ocrIngestionResults`);
					}
				},
			});
		}
	};

	render() {
		const { classes, open } = this.props;
		return (
			<Dialog
				maxWidth="sm"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper,
				}}
			>
				<DialogTitle>Invalidate Triage Result</DialogTitle>
				<DialogContent>
					<TextField
						value={this.state.invalidReason}
						onChange={(event) => this.onChange(event, 'invalidReason')}
						label="Reason for marking triage result invalid"
						fullWidth
					/>
				</DialogContent>

				<div className={classes.question}>
					Are you sure you want to mark this triage result invalid?
				</div>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>Close</Button>
						<Button
							variant="contained"
							onClick={this.handleInvalidate}
							className={classes.warningButton}
						>
							Yes, mark result as invalid
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmInvalidateApArTriage.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	apIngestionResultId: PropTypes.number,
	ocrIngestionResultId: PropTypes.number,
	invalidateTriageResult: PropTypes.func.isRequired,

	//- Could be either
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(ConfirmInvalidateApArTriage);
